<template lang="pug">
b-tr.usage-fees-tokuyo-living-costs-table-row
  b-td.room-name {{ roomName }}
  b-td
    .d-flex.flex-row.align-items-center
      b-form-input.mr-1(v-model.number="_value.paymentCeiling_1"
        :name="'usage-fees-tokuyo-' + roomId + '-payment-ceiling-1'"
        :maxlength="10" :class="[ { noinput: _value.paymentCeiling_1 == null } ]"
        v-validate="{ required: true, max: 10 }" :data-vv-as="roomName + 'の第1段階'")
      span 円
  b-td
    .d-flex.flex-row.align-items-center
      b-form-input.mr-1(v-model.number="_value.paymentCeiling_2"
        :name="'usage-fees-tokuyo-' + roomId + '-payment-ceiling-2'"
        :maxlength="10" :class="[ { noinput: _value.paymentCeiling_2 == null } ]"
        v-validate="{ required: true, max: 10 }" :data-vv-as="roomName + 'の第2段階'")
      span 円
  b-td
    .d-flex.flex-row.align-items-center
      b-form-input.mr-1(v-model.number="_value.paymentCeiling_3_1"
        :name="'usage-fees-tokuyo-' + roomId + '-payment-ceiling-3-1'"
        :maxlength="10" :class="[ { noinput: _value.paymentCeiling_3_1 == null } ]"
        v-validate="{ required: true, max: 10 }" :data-vv-as="roomName + 'の第3段階①'")
      span 円
  b-td
    .d-flex.flex-row.align-items-center
      b-form-input.mr-1(v-model.number="_value.paymentCeiling_3_2"
        :name="'usage-fees-tokuyo-' + roomId + '-payment-ceiling-3-2'"
        :maxlength="10" :class="[ { noinput: _value.paymentCeiling_3_2 == null } ]"
        v-validate="{ required: true, max: 10 }" :data-vv-as="roomName + 'の第3段階②'")
      span 円
  b-td
    .d-flex.flex-row.align-items-center
      b-form-input.mr-1(v-model.number="_value.paymentCeiling_4"
        :name="'usage-fees-tokuyo-' + roomId + '-payment-ceiling-4'"
        :maxlength="10" :class="[ { noinput: _value.paymentCeiling_4 == null } ]"
        v-validate="{ required: true, max: 10 }" :data-vv-as="roomName + 'の第4段階'")
      span 円
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

import { PaymentCeiling } from "@/commons/services/WaiterRecruitments";

/**
 * ### 料金シミュレーション(特養タイプ) 部屋料金コンポーネント
 */
@Component({})
export default class UsageFeesTokuyoLivingCostsTableRow extends Vue {
  /** 親コンポーネントのバリデーターをInjectionする */
  @Inject("$validator") $validator!: Validator;

  @Prop()
  value!: PaymentCeiling;

  @Prop()
  roomId!: string;
  @Prop()
  roomName!: string;

  get _value(): PaymentCeiling {
    return this.value;
  }

  set _value(newValue: PaymentCeiling) {
    this.$emit("input", newValue);
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.usage-fees-tokuyo-living-costs-table-row {
  .room-name {
    width: 140px;
  }

  .noinput {
    background-color: $bg-require-input !important;
    &::placeholder {
      color: rgb(117, 117, 117);
    }
  }
}
</style>
